// Library Methods
import { useRoutes } from "react-router-dom";

// Route definitions
import routes from "./navigation/routes";

const App = () => {
  const content = useRoutes(routes);
  return content;
};

export default App;
